import React from 'react';
import dayjs, { Dayjs } from 'dayjs';
import SingleDatePicker from '../../components/ui/SingleDatePicker';

interface BookingDatePickerProps {
    value: Dayjs | null;
    onChange?: (date: Dayjs | null) => void;
    // Declared for back-compat with existing callsites — the legacy MUI
    // wrapper ignored this in favour of `availableDates`. Same here:
    // `availableDates` (when provided) is authoritative.
    shouldDisableDate?: (date: Dayjs | null) => boolean;
    availableDates?: string[];
    label: string;
    disabled?: boolean;
    disableFuture?: boolean;
    disablePast?: boolean;
}

// Booking-flow date picker. Thin wrapper over `SingleDatePicker` that keeps
// the public API the 11+ callsites depend on. Behavioural parity with the
// previous MUI MobileDatePicker:
//   - 18-month forward cap (existing convention; bookings don't go further).
//   - `availableDates` (YYYY-MM-DD list) restricts selectable days.
//   - `disablePast` / `disableFuture` honoured.
const BookingDatePicker: React.FC<BookingDatePickerProps> = React.memo((props) => {
    const maxDate = React.useMemo(() => dayjs().add(18, 'month').endOf('month'), []);

    return (
        <SingleDatePicker
            value={props.value}
            onChange={props.onChange}
            label={props.label}
            disabled={props.disabled}
            disablePast={props.disablePast}
            disableFuture={props.disableFuture}
            allowedDays={props.availableDates}
            maxDate={maxDate}
        />
    );
});

BookingDatePicker.displayName = 'BookingDatePicker';

export default BookingDatePicker;
